import $ from 'jquery';
import Animation from 'modules/animation/animation';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaConnectPromo',
			dom: {
				formCaptcha: '.js-connect-promo-captcha-form',
				formCode: '.js-connect-promo-code-form',
				shake: '.js-connect-promo-shake',
				resend: '.js-connect-promo-resend',
				blocked: '.js-connect-promo-blocked',
				field: '.js-field',
				input: '.js-field-input'
			},
			classes: {
				form: {
					send: {
						blocked: 'b-connect-promo__form_send_blocked'
					}
				},
				field: {
					state: {
						error: 'b-field_state_error'
					}
				}
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.sended = false;
		this.timer = 0;
		this.interval = false;
		return this;
	}

	getDom() {
		this.$formCaptcha = this.$el.find(this.options.dom.formCaptcha);
		this.$formCode = this.$el.find(this.options.dom.formCode);
		this.$resend = this.$el.find(this.options.dom.resend);
		this.$blocked = this.$el.find(this.options.dom.blocked);
		if (this.$formCaptcha.length) {
			this.$shake = this.$formCaptcha.find(this.options.dom.shake);
		}
		if (this.$formCode.length) {
			this.$shake = this.$formCode.find(this.options.dom.shake);
		}
		if (this.$formCaptcha.length || this.$formCode.length) {
			this.$field = this.$shake.find(this.options.dom.field);
			this.$input = this.$shake.find(this.options.dom.input);
		}
		return this;
	}

	onSubmitCaptcha(e) {
		const self = this;
		if (this.$input.val().trim() == '') {
			self.$field.addClass(self.options.classes.field.state.error);
			self.shake.play('shake');
		} else if (!self.sended && self.$formCaptcha.data('send') == 'ajax') {
			self.sended = true;
			$.ajax({
				url: self.$formCaptcha.attr('action'),
				type: self.$formCaptcha.attr('method'),
				data: self.$formCaptcha.serialize(),
				dataType: 'json',
				success: function (json) {
					if (json && json.success) {
						if (json.location) {
							window.location.assign(json.location);
						}
					} else {
						self.shake.play('shake');
						self.$field.addClass(self.options.classes.field.state.error);
					}
					self.sended = false;
				}
			});
			e.preventDefault();
		}
	}

	onSubmitCode(e) {
		const self = this;
		if (this.$input.val().trim() == '') {
			self.$field.addClass(self.options.classes.field.state.error);
			self.shake.play('shake');
		} else if (!self.sended && self.$formCode.data('send') == 'ajax') {
			self.sended = true;
			$.ajax({
				url: self.$formCode.attr('action'),
				type: self.$formCode.attr('method'),
				data: self.$formCode.serialize(),
				dataType: 'json',
				success: function (json) {
					if (json && json.success) {
						if (json.location) {
							window.location.assign(json.location);
						}
					} else {
						self.shake.play('shake');
						self.$field.addClass(self.options.classes.field.state.error);
					}
					self.sended = false;
				}
			});
			e.preventDefault();
		}
	}

	declOfNum(number, titles) {
		const cases = [2, 0, 1, 1, 1, 2];
		return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
	}

	updateTimer() {
		let text = this.$blocked.data('template').trim();
		text += ' ' + this.timer + ' ' + this.declOfNum(this.timer, ['секунду', 'секунды', 'секунд']);
		this.$blocked.html(text);
	}

	startTimer(time) {
		this.timer = time - 1;
		this.updateTimer();
		this.$formCode.addClass(this.options.classes.form.send.blocked);
		clearInterval(this.interval);
		this.interval = setInterval(this.stopTimer.bind(this), 1000);
		return this;
	}

	stopTimer() {
		this.timer--;
		this.updateTimer();
		if (this.timer <= 0) {
			this.$formCode.removeClass(this.options.classes.form.send.blocked);
			clearInterval(this.interval);
		}
		return this;
	}

	onResend() {
		const self = this;
		if (self.timer <= 0) {
			$.ajax({
				url: self.$formCode.attr('action'),
				type: self.$formCode.attr('method'),
				data: {type: 'resend'},
				dataType: 'json',
				success: function (json) {
					if (json && json.success) {
						if (json.location) {
							window.location.assign(json.location);
						}
						self.startTimer(json.timer || 60);
					} else {
						$(() => new Animation({el: self.$resend}).play('shake'));
					}
					self.sended = false;
				},
				error: function () {
					self.sended = false;
				}
			});
		}
	}


	onFocus() {
		this.$field.removeClass(this.options.classes.field.state.error);
		return this;
	}

	render() {
		if (this.$el.length) {
			this.getDom();

			this.shake = new Animation({el: this.$shake});
			if (this.$input.length) {
				this.$input.on('focusin', this.onFocus.bind(this));
			}
			if (this.$formCaptcha.length) {
				this.$formCaptcha.on('submit', this.onSubmitCaptcha.bind(this));
			}

			if (this.$formCode.length) {
				this.$formCode.on('submit', this.onSubmitCode.bind(this));
			}

			if (this.$resend.length) {
				this.$resend.on('click', this.onResend.bind(this));
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/connect-promo/connect-promo.js